import localForage from 'localforage';
import { useEffect, useState } from 'react';
import { Greet } from '~/types/models';

const key = 'bulk-select-roll-ups';
const useRollUpState = () => {
  const [rollUp, setRollUp] = useState<Greet[]>([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const loadRollUp = async () => {
      setLoading(true);
      setRollUp((await localForage.getItem<Greet[]>(key)) ?? []);
      setLoading(false);
    };

    loadRollUp();
  }, []);

  return {
    rollUp,
    setRollUp: (rollup: Greet[]) => localForage.setItem(key, rollup),
    isLoading,
  };
};

export default useRollUpState;
